import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  & svg {
    color: ${({ theme }) => theme?.colors?.blue};
    font-size: 22px;
  }
`;

export const DropdownMenu = styled.div`
  min-width: 200px;
  z-index: 5;
  background: white;
  position: absolute;
  top: 45px;
  right: 0;
  border-radius: 5px;
  box-shadow: 0 0 8px #d8d8d8;
  display: flex;
  padding: 12px;
  flex-direction: column;
`;

export const DropdownItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 5px;
  border: none;
  background-color: transparent;
  outline: none;

  & svg {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.blue};
  }

  & span {
    text-align: left;
  }
`;

export const DropdownText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
  margin-left: 7px;
  flex: 1;

  ${DropdownItem}:hover & {
    color: ${({ theme }) => theme.colors.blue};
  }
`;
